<template>
    <div class="c-services component">
        <h3 class="text-upper">SERWIS</h3>
        <div class="flex-row">
            <div class="flex-col mt--1 mb--2">
                <SelectInput class="v-brand__select" :selectedValue="getSelectedDealer? getSelectedDealer.name: null">
                    <ul slot="list">
                        <li><strong>Serwis mechaniczny</strong></li>
                        <li v-for="dealer in getDealers" v-on:click="lead.dealer_id = dealer.id">{{ dealer.name }} ({{dealer.city}})</li>
                    </ul>
                </SelectInput>
            </div>
        </div>
        <h3 class="text-upper">Preferowany termin</h3>
        <div class="flex-row">
            <div class="flex-col mt--2 mb--2">
                <span class="label">Data przyjęcia</span>
                <br>
                <label>
                    <input type="radio" name="date_mode" v-model="lead.visit_date_val" v-on:click="lead.date_from = nextDay" :value="false"> Możliwie najszybciej
                </label>
                <br>
                <label>
                    <input type="radio" name="date_mode" v-model="lead.visit_date_val" :value="true"> Wizyty od
                </label>
                <div class="flex-col">
                    <date-picker v-model="lead.date_from" valueType="format" :lang="getDetepickerConfig" v-if="lead.visit_date_val === true" :disabled-date="getDetepickerConfig.range"></date-picker>
                </div>
            </div>
            <div class="flex-col mt--2 mb--2">
                <span class="label">Godzina przyjęcia</span>
                <br>
                <label v-if="!lead.visit_date_val">
                   <input type="radio" name="date_time" :value="getTimeOfDayWithDealersHours[0].val" v-model="lead.visit_hour_val" v-on:click="lead = {...lead,hour_from:nextTime, hour_to:getTimeOfDayWithDealersHours[0].term.hour_to, visit_hour_name: getTimeOfDayWithDealersHours[0].name}"> {{ getTimeOfDay[0].name }}
                    <br>
                </label>
                <label v-for="timeOfDay in getTimeOfDayWithDealersHours" v-if="!lead.visit_date_val && timeOfDay.val != 1 || lead.visit_date_val">
                    <input type="radio" name="date_time" :value="timeOfDay.val" v-model="lead.visit_hour_val" v-on:click="lead = {...lead, ...timeOfDay.term, visit_hour_name: timeOfDay.name}"> {{ timeOfDay.name }}
                    <br>
                </label>
            </div>
        </div>

        <h3 class="text-upper">DALSZE OPCJE</h3>
        <div class="flex-row">
            <div class="flex-col">
                <template v-for="additionalOption in getAdditionalOptions">
                    <label class="mt--2">
                        <input type="checkbox" :value="additionalOption.val"  v-on:click="pushAdditionalOption(additionalOption)"> {{ additionalOption.name }}
                        <br>
                    </label>
                    <div class="flex-col flex-col--4" v-if="additionalOption.val == 'Potrzebuję mobilności' && lead.additional_options_val.indexOf(additionalOption.val) != -1">
                        <SelectInput :selectedValue="getReplacementCars.filter(e => e.id == lead.replacement_car_id? e.model : false ).map(e => e.brand+' '+e.model)">
                            <ul slot="list">
                                <li><strong>Wszystkie kategorie</strong></li>
                                <li v-for="car in getReplacementCars" v-on:click="lead.replacement_car_id = car.id; lead.replacement_car_val = car.brand+' '+car.model">
                                    <strong>{{ car.brand }} {{ car.model }}</strong>
                                    <br>
                                    <small style="font-size:1rem">Płatny zamochód zastępczy BMW {{ lead.dealer_id?'-'+replacementCarPrices[lead.dealer_id]+'zł netto / doba':'' }}</small>
                                </li>
                            </ul>
                        </SelectInput>
                    </div>
                </template>

            </div>
        </div>

    </div>
</template>
<script>

import {mapActions,mapGetters} from 'vuex';

import lead from '@/mixins/lead.js'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    data(){
        return {
            replacementCarPrices:{
                1:69, //Poznań
                2:269, //Warszawa
                3:100 //Wrocław
            }
        }
    },
    components:{
        DatePicker
    },
    computed:{
        ...mapGetters({
            getTimeOfDay:'definitions/getTimeOfDay',
            getAdditionalOptions: 'definitions/getAdditionalOptions',
            getDealers: 'definitions/getDealers',
            getReplacementCars:'definitions/getReplacementCars',
            getDetepickerConfig:'definitions/getDetepickerConfig',
            getFirstPossibleDate:'definitions/getFirstPossibleDate',
            getTimeOfDayWithDealersHours:'definitions/getTimeOfDayWithDealersHours'
        }),
        getSelectedDealer() { return this.getDealers.find( e => e.id == this.lead.dealer_id) },
        nextDay(){
            var date = this.getFirstPossibleDate;
            date.setHours(date.getHours());
            return date.toISOString().split('T')[0]
        },
        nextTime(){
            var date = this.getFirstPossibleDate;
            var hours = Number(date.toISOString().split('T')[1].split(':')[0])
            return hours;
        }
    },
    mixins:[lead],
    methods:{
        ...mapActions({
            fetchDealers:'definitions/fetchDealers',
            fetchServiceCars:'definitions/fetchServiceCars',
            getFirstPossibleDate:'definitions/getFirstPossibleDate'
        }),
        pushAdditionalOption(additionalOption){
            if(additionalOption.val == 'Potrzebuję mobilności'){
                this.lead.replacement_car = 1 // remove selected car
                this.fetchServiceCars();
            }
            let id = this.lead.additional_options_val.indexOf(additionalOption.val);
            if(id != -1){
                this.lead.additional_options_val.splice(id, 1);
            }else{
                this.lead.additional_options_val.push(additionalOption.val)
            }
        }
    },
    mounted(){
        this.fetchDealers();
    }
}
</script>
<style lang="scss">

</style>
